import { atom} from 'recoil';

export interface ITabIndex {
  index: number;
  editMode: boolean;
}

export const tabIndexState = atom<number>({
  key: 'tabIndexState',
  default: -1,
});

